export const NAV_LINKS = [
  { label: "About Us", path: "/about-us" },
  { label: "Our Services", path: "/our-services" },
  { label: "Our Products", path: "/our-products" },
  { label: "Contact Us", path: "/contact-us" },
];
